import { getCostCentersAccountNumbers } from '@api/cost-centers/cost-centers.service';
import { useQuery } from '@tanstack/react-query';

export const useAccounts = () => {
  const { data, isLoading } = useQuery({
    queryKey: ['cost-centers-account-numbers'],
    queryFn: async () => {
      const accountNumbers = await getCostCentersAccountNumbers();
      return accountNumbers.map((accountNumber) => ({
        label: accountNumber.iban,
        value: accountNumber.id,
      }));
    },
    initialData: [],
  });

  return { accountNumbersOptions: data, isLoading };
};
